import {
  GET_EXPENSEDASHBOARD_DATA_SUCCESS,
  GET_EXPENSEDASHBOARD_DATA_FAILS,
} from "../actionTypes";

const initialState = {
  expenseData: [],
};

const memberExpenseApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EXPENSEDASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        expenseData: action.payload,
      };
    case GET_EXPENSEDASHBOARD_DATA_FAILS:
      return {
        ...state,
        isLoggedIn: false,
        expenseData: null,
      };
    default:
      break;
  }
  return state;
};

export default memberExpenseApprovalReducer;
